import { render, staticRenderFns } from "./EntityImportModal.vue?vue&type=template&id=0dd36d15&scoped=true&lang=html&"
import script from "./EntityImportModal.vue?vue&type=script&lang=js&"
export * from "./EntityImportModal.vue?vue&type=script&lang=js&"
import style0 from "./EntityImportModal.vue?vue&type=style&index=0&id=0dd36d15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd36d15",
  null
  
)

export default component.exports